module.exports = __webpack_public_path__ + "img/7.959e0e6f.png";